module.exports = __webpack_public_path__ + "media/images/webdesign/hg_img-ad7ff62d2c8a055d644f3fd43af9c850.jpg";